import { CONFIGURATOR_URL } from '../config/constant/apiConstant';
import ThumbnailCardUI from './ThumbnailCardUI';

export const ThumbnailCardConfigurators = ({ data, size, fullWidth, selected, ...rest }) => {
  const url = `${CONFIGURATOR_URL}?${data?.token}/${data.id}/1`;
  const openUrlInNewTab = () => {
    window.open(url, '_blank');
  }

  return (
    <ThumbnailCardUI
      key={data.id}
      id={data.id}
      target="_blank"
      thumbnail={data.thumb}
      name={data.name}
      size={size}
      titleProps={{
        onClick: openUrlInNewTab
      }}
      onLinkClick={openUrlInNewTab}
      fullWidth={fullWidth}
      data={data}
      {...rest}
    />
  );
};
